export default __webpack_public_path__ + "static/media/image-3.2ece938c.svg";